import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface ElevenLabsAgent {
  agentId: string;
  name: string;
}

async function getElevenLabsAgents(auth: Authentication | null): Promise<ElevenLabsAgent[]> {
  try {
    if (!auth) {
      throw new GetElevenLabsAgentsFailure(
        'Vous devez être connecté pour effectuer cette action.',
        'unauthorized'
      );
    }

    const json = await HttpClient.get('/elevenlabs/agents', auth.token);

    return json.data.agents;
  } catch (e) {
    if (e instanceof GetElevenLabsAgentsFailure) throw e;
    console.log('error: ', e);
    throw new GetElevenLabsAgentsFailure();
  }
}

export class GetElevenLabsAgentsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getElevenLabsAgents;
